<template>
  <div
    class="filter-wrapper next-filter-wrapper"
    data-sb-automation="filter-wrapper"
    data-sb-regression="sb-filter-wrapper"
  >
    <div
      class="filter-names"
      data-sb-automation="filter-names"
    >
      <div
        v-for="(filter, index) in filters"
        :key="filter.key"
        class="filter-name"
        :data-sb-automation="`filter-name-${filter.key}`"
        :class="[ index === selectedFilter ? 'selected-filter-label' : '']"
        @click="selectFilter(index)"
      >
        <div class="filter-name-text-container">
          <div
            class="filter-name-text-container-dot-container"
            :class="[internalValues[filter.key] || values[filter.key] ?
              'filter-name-text-container-dot-container-show' : '']"
          >
            <div
              v-if="(internalValues[filter.key] &&
                (Array.isArray(internalValues[filter.key].value)
                  ? internalValues[filter.key].value.length : ![null, ''].includes(internalValues[filter.key].value)))"
              class="filter-name-text-container-dot-container-icon filter-name-text-container-dot-container-icon-filled"
            />
          </div>
          <sb-text
            class="filter-name-text-container-text"
            :value="filter.name"
          />
        </div>
        <sb-svg-icon
          class="filter-name-icon"
          :svg="icon"
        />
      </div>
    </div>
    <div class="selected-filter-container">
      <div
        v-for="(filter, index) in filters"
        :key="filter.key"
      >
        <component
          :is="getComponent(filter)"
          v-if="index === selectedFilter"
          v-model="internalValues[filter.key]"
          :version="dsComponentDetails.version"
          :filter="filter"
          :value="getValue(filter.key)"
          @update-filter="handleUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SbSvgIcon from '@src/components/Icons/components/SbSvgIcon.vue';
import SbText from '@src/components/Text/SbText.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbCollapsableFilter from '@src/components/Filter/components/SbCollapsableFilter.vue';
import SbDynamicCollapsableFilter from '@src/components/Filter/components/SbDynamicCollapsableFilter.vue';

export default {
  name: 'SbFilterWrapper',
  components: {
    SbDynamicCollapsableFilter,
    SbCollapsableFilter,
    SbSvgIcon,
    SbText,
  },
  mixins: [versionedComponentsMixin],
  props: {
    /**
       * Collection of filter definitions to render
       */
    filters: {
      type: Array,
      required: true,
    },
    /**
       * Object containing current value of filters to display
       * Each key should match a key on the 'filters' prop array
       */
    values: {
      type: Object,
      default: () => {},
    },
  },
  emits: [
    /**
       * Emitted when the filter is applied
       */
    'filters-updated',
  ],
  data: () => ({
    internalValues: {},
    tempInternalValues: {},
    selectedFilter: 0,
    icon: `<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" height="12" width="7" viewBox="0 0 320 512" fill="#2470af">
      <path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/>
    </svg>`,
  }),
  watch: {
    values(newValues) {
      // override internal values if parent changes (i.e. Reset All)
      this.internalValues = { ...newValues };
    },
  },
  mounted() {
    this.internalValues = { ...this.values };
  },
  methods: {
    getComponent(filter) {
      if (filter.wrapper) return filter.wrapper;
      if (filter.dynamic && this.dsComponentDetails.version === 'next') return SbDynamicCollapsableFilter;
      return SbCollapsableFilter;
    },
    getValue(key) {
      return this.internalValues[key];
    },
    handleUpdate({ key, value }) {
      this.internalValues[key] = value;
      this.$emit('filters-updated', this.internalValues);
    },
    selectFilter(newFilterIndex) {
      this.selectedFilter = newFilterIndex;
    },
  },
};
</script>
<style lang="scss">
@import '@src/components/Filter/style/sb-filter-wrapper.scss';
</style>
